import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { SeparatorProps } from "@/types";
import { useMargins } from "@/hooks";


/**
 * A generic component for drawing a line separator.
 */
const __default__ = {
  name: "Separator",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    vertical: { type: Boolean },
    inset: { type: Boolean },
    nav: { type: Boolean },
    x: {},
    y: {},
    l: {},
    r: {},
    t: {},
    b: {},
    class: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;

const className = useMargins(props, () => [
  ["nav", "faded"],
  ["class", props.class],
]);

const separatorColor = computed(() => {
  if (props.color) {
    return props.color;
  } else if (props.nav) {
    return "text";
  } else {
    return undefined;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createBlock(_component_q_separator, {
    class: _normalizeClass(_unref(className)),
    vertical: props.vertical,
    inset: props.inset,
    color: separatorColor.value
  }, null, 8, ["class", "vertical", "inset", "color"]))
}
}

})